angular.module('core').service('dblProductResourcesService', [function () {

    var _this = this;
    var _productApiUrl;
    var _contentRoot;
    var mapLocaleToLangParam = {
        'es_US': 'es'
    };


    this.init = function (productApiUrl, contentRoot) {
        _productApiUrl = productApiUrl;
        _contentRoot = contentRoot;
    };

    this.getSchoolCode = function (districtUrlIdentifier, urlIdentifier) {
        return districtUrlIdentifier + '/' + urlIdentifier;
    };

    this.getStudentLoginUrl = function (districtUrlIdentifier, urlIdentifier) {
        if (!districtUrlIdentifier || !urlIdentifier) {
            return;
        }

        return _productApiUrl + '/login/' + _this.getSchoolCode(districtUrlIdentifier, urlIdentifier);
    };

    this.getParentInvitationLetterUrl = function (idType, itemId, locale) {
        var baseUrl = _productApiUrl + '/teachers/pdf_login_info';
        var itemParam = idType + '=' + itemId;

        if (mapLocaleToLangParam[locale]) {
            return baseUrl + '?lang=' + mapLocaleToLangParam[locale] + '&' + itemParam;
        } else {
            return baseUrl + '?' + itemParam;
        }
    };

    this.getSubscriptionInfoUrl = function () {
        return _productApiUrl + '/dashboard/store/subscribe?source=insight';
    };

    this.getParentInvitationLetterSSOUrl = function (locale) {
        var base = _productApiUrl + '/docs/dreambox-sso-parent-login-';

        if (locale === 'es_US') {
            return base + 'spanish.pdf';
        } else {
            return base + 'english.pdf';
        }
    };

    this.getContentRoot = function () {
        return _contentRoot;
    };

}]);
